<template>
  <div id="ca-chip-filtros">
    <v-chip
      v-for="chip in datos"
      :key="chip.estado"
      @click="clicked(chip)"
      :class="{'selected-border': chip.selected}"
      :disabled="chip.disabled" :title="chip.title"
    >
      <v-icon v-if="tieneEstado(chip)" :class="{...clasesIndicador(chip)}" :size="8">lens</v-icon>
      <span :class="{'chip-text': tieneEstado(chip)}">
        {{chip.texto}}
        <span v-if="chip.cantidad || con_cant_cero">({{chip.cantidad}})</span>
        <span v-if="chip.importe">$ <span :class="{'monto-negrita': monto_negrita}">{{chip.importe | formatMontoCentavos()}}</span></span>
      </span>
    </v-chip>
  </div>
</template>

<script>

export default {
  props: {

    /**
       * En datos se debe pasar, modelado en objetos, todos los estados, labels, montos y demás info para la estilización del chip.
       *
       * Atributos aceptados:
       *  - estado: (opcional) <string> color que se le asignará al chip. Estados posibles: 'ok', 'danger', 'warning', 'default' o 'sin-estado'
       *  - texto: (obligatorio) <string> label del chip, el componente le agrega ':'
       *  - selected: (opcional) <boolean> indica si el chip esta seleccionado
       *  - disabled: (opcional) <boolean> indica si el chip esta deshabilitado
       *  - title: (opcional) <string> texto para mostrar al hacer hover en el chip
       *  - importe: (opcional) <number> importe que se mostrará en el chip
       *  - cantidad: (opcional) <string> cantidad que se mostrará en el chip
       */
    datos: {
      type: Array,
      default: function () {
        return [];
      },
    },
    multiples_filtros: { type: Boolean, default: false }, // Indica si se permiten seleccionar múltiples filtros o de a uno
    con_cant_cero: { type: Boolean, default: false }, // Indica si se debe mostrar la cantidad entre "( )" cuando es 0
    monto_negrita: { type: Boolean, default: false }, // Indica si el monto debe estar en negrita
  },
  methods: {
    tieneEstado(chip) {
      if (chip.estado) {
        return chip.estado !== 'sin-estado';
      }
      return false;
    },
    clasesIndicador(chip) {
      return {
        'ca-indicador': this.tieneEstado(chip),
        'ca-indicador--ok': this.tieneEstado(chip) && chip.estado === 'ok',
        'ca-indicador--warning': this.tieneEstado(chip) && chip.estado === 'warning',
        'ca-indicador--danger': this.tieneEstado(chip) && chip.estado === 'danger',
      };
    },

    /**
       * Método hookeado a evento click en v-chip.
       * Emite evento con chip clickeado y los chips seleccionados, en caso de permitirse selección múltiple.
       * Setea el valor de la propiedad 'selected' del chip y,
       * si habia otro chip seleccionado y no se permiten mútiples filtros seleccionados, los deselecciona
       */
    clicked(chip) {
      let chips_selected = [];
      chip.selected = !chip.selected;
      if (!this.multiples_filtros) {
        for (let dato of this.datos) {
          if (dato !== chip) {
            dato.selected = false;
          }
        }
      } else {
        chips_selected = this.datos.filter(dato => dato.selected);
      }
      this.$emit('update:filtro', chip, chips_selected);
    }
  }
};
</script>

<style lang="scss">
  #ca-chip-filtros {
    /** Indicador */
    .ca-indicador.v-icon {
      font-size: 12px;

      &.ca-indicador--ok {
        color: color(verde) !important;
      }

      &.ca-indicador--warning {
        color: color(warning) !important;
      }

      &.ca-indicador--danger {
        color: color(rojo) !important;
      }
    }

    .selected-border {
      border: solid 1px color(gris) !important;
    }

    .chip-text {
      padding-left: 10px;
      text-transform: capitalize;
    }

    .monto-negrita {
      font-weight: bold;
    }

    .v-chip {
      padding: 0 18px;
      margin-right: 12px;
    }
  }
</style>